import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/api.service';
import { saveAs } from 'file-saver';
import { Common } from '../shared/common';
import { ReceivedPoll } from '../models/ReceivedPoll';
import { ParticipationResponse } from '../models/ParticipationResponse';
import { ShortVoter, VoterVotedResponse } from '../models/ShortVoter';
import { AssessorData } from '../models/AssessorData';
import { DisplayResult } from '../models/DisplayResult';
import { environment } from 'src/environments/environment.staging';


@Component({
  selector: 'app-poll-finished',
  templateUrl: 'poll-finished.component.html',
  styleUrls: ['./poll-finished.component.less', '../shared/common.less']
})

export class PollFinishedComponent implements OnInit {
  pollId: string;
  title: string;
  pollData: ReceivedPoll;
  votingType: string;
  startDate = '';
  endDate = '';
  votersCount = 0;
  description = '';
  votes = 0;
  percentage = 0;
  isLive: boolean;
  isPublic: boolean;
  SMSOption: boolean;
  isSending = false;
  percentageString = '0';
  isError = false;
  errorMessage: string;
  displayIndex: number;
  realIndex: number;
  shouldReturnToPoll = false;
  resultsShared = false;
  shouldDisplaySharePopup = false;
  isShareEnabled = true;
  is2FA: any;
  endDateFormat: Date;
  language = 'fr';
  hasAssessors = false;
  calculating: boolean;
  timer: any;
  assessorsValidated: boolean;
  canResendAssessors: boolean;
  remainingAssessorTime: string;
  shouldAssessorConvocationWarning: boolean;
  inactiveAssessors: ShortVoter[];
  remainingAssessors: number;
  displayAssessorPopup: boolean;
  assessors: number;
  isActive = false;
  displayVoterStatus = '';
  displayedVoters: ShortVoter[];
  votersTitle = '';
  activeElectionToDisplay: number = 0;
  resultsToDisplay: DisplayResult[];
  results: Array<Array<number>>;
  blockchainLink: string;
  selectedCollege = 1;
  electedCount = 0;
  representativePopup = false;
  representationData = null;

  constructor(private router: Router,
    private apiService: ApiService,
    private route: ActivatedRoute,
    public common: Common
  ) { }

  downloadDocuments() {
    this.downloadCsv();
    this.downloadVoters();
    this.downloadVotersPdf();
    this.downloadResultsPdf();
    if (this.isLive) { this.downloadParticipation(); }
  }

  downloadRepresentation() {
    // const name = 'Représentativité.zip';
    this.apiService.getRepresentationData(this.pollId).subscribe((res => {
      // Convertir en tableau si ce n'est pas déjà le cas
      this.representationData = Array.isArray(res) ? res : [res];
      this.representativePopup = true;

    }));
  }

  sendTelTrans() {
    this.apiService.sendTTData(this.pollId).subscribe((res) => {
      console.log(res);
    });
  }

  downloadCerfa() {
    const name = 'Cerfa.zip';
    this.apiService.getCerfaFile(this.pollId).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/zip\n' });
      saveAs(blob, name);
    });
  }

  selectCollege(college: number) {
    this.selectedCollege = college;
    const newIndex = this.pollData.rounds.findIndex((p) => p.college === college);
    if (newIndex >= 0) {
      this.setActiveElectionToDisplay(newIndex);
    }
  }

  setActiveElectionToDisplay(i) {
    this.activeElectionToDisplay = i;
    const answers = this.pollData.rounds[i].displayedQuestions[0].answers;
    this.results = JSON.parse(this.pollData.rounds[i].results as string) as Array<Array<number>>;
    let tmpResults = [...this.results.map(arr => [...arr])];
    tmpResults.shift();

    const tmpArrayRes = answers.map((answer, index) => {
      const candidates = this.pollData.rounds[i].displayedQuestions.filter(q => q.parent === index).length;

      const extractedResults = tmpResults.splice(0, candidates);
      return extractedResults;
    });
    this.resultsToDisplay = answers.map((answer, index) => new DisplayResult(
      answer || '',
      this.pollData.rounds[i].displayedQuestions[0].listImages[index] || '',
      this.pollData.rounds[i].displayedQuestions.filter(q => q.parent === index).map(q => q.question) || [],
      this.pollData.rounds[i].displayedQuestions.filter(q => q.parent === index).map((q, idxImage) => q.listImages[idxImage]) || [],
      tmpArrayRes[index] || [],
      this.pollData.rounds[i].cseResults.candidatesWithResults.filter(val => val.listKey === index).map(cand => cand.isElected)
    ));
    this.electedCount = this.resultsToDisplay.reduce((sum, college) => sum + (college.electedCount || 0), 0);
  }

  handleAssessorSendStatus() {
    this.apiService.canUseAssessorOpeningSend(this.pollId).subscribe((res) => {
      this.canResendAssessors = true;
    }, (err: any) => {
      this.canResendAssessors = false;
      if (err.status === 403) {
        const inviteTresholdTimestamp = new Date(err.error).getTime();
        const timeDiffTimestamp = inviteTresholdTimestamp - new Date().getTime();
        const displayedHours = Math.floor(timeDiffTimestamp / 1000 / 60 / 60);
        const displayedMinutes = Math.floor((timeDiffTimestamp - (displayedHours * 1000 * 60 * 60)) / 1000 / 60);
        const displayedHrString = displayedHours > 9 ? displayedHours.toString() : '0' + displayedHours;
        const displayedMinString = displayedMinutes > 9 ? displayedMinutes.toString() : '0' + displayedMinutes;
        this.remainingAssessorTime = `${displayedHrString}h${displayedMinString}m`;
      }
      if (err.status === 410) {
        this.remainingAssessorTime = null;
      }
    });
  }

  getRemainingAssessors() {
    this.apiService.getNonClosingAssessors(this.pollId).subscribe((res: Array<AssessorData>) => {
      // this.inactiveAssessors = res.map(x => ShortVoter.withEmailAndName(x.email, x.name));
      this.inactiveAssessors = res.map(x => ShortVoter.withEmail(x.name + " - " + x.email));
      if (this.inactiveAssessors != undefined) {
        this.displayAssessorPopup = true;
        this.remainingAssessors = this.inactiveAssessors.length;
      }
    });
  }

  dismissAssessorsPopup() {
    this.displayAssessorPopup = false;
  }

  relaunchAssessors() {
    this.apiService.relunchNonClosingAssessors(this.pollId).subscribe(res => {
      this.shouldAssessorConvocationWarning = false;
      this.handleAssessorSendStatus();
    }, (err: any) => {
      console.log(err);
    });
  }
  downloadResultsPdf() {
    const name = this.getResultExcelName('pdf');
    if (this.displayIndex < 0) {
      if (this.votingType === 'list' && this.pollData.rounds.length > 1) {
        for (const round of this.pollData.rounds) {
          this.apiService.getResultsPdfRound(this.pollId, round.round, this.language).subscribe((res) => {
            const blob = new Blob([res], { type: 'application/pdf\n' });
            saveAs(blob, round.title + ' ' + name);
          });
        }
      } else {
        this.apiService.getResultsPdf(this.pollId, this.language).subscribe((res) => {
          const blob = new Blob([res], { type: 'application/pdf\n' });
          saveAs(blob, name);
        });
      }
    } else {
      this.apiService.getResultsPdfRound(this.pollId, this.realIndex, this.language).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/pdf\n' });
        saveAs(blob, name);
      });
    }
  }

  downloadVotersPdf() {
    const name = this.common.getVotersExcelName('pdf', this.language);
    if (this.displayIndex < 0) {
      this.apiService.getVotersPdf(this.pollId, this.language).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/pdf\n' });
        saveAs(blob, name);
      });
    } else {
      this.apiService.getVotersPdfRound(this.pollId, this.displayIndex, this.language).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/pdf\n' });
        saveAs(blob, name);
      });
    }
  }

  getResultExcelName(ext: string) {
    switch (this.language) {
      case 'fr': return `Resultats.${ext}`;
      case 'es': return `Resultados.${ext}`;
      default: return `Results.${ext}`;
    }
  }

  downloadCsv() {
    const name = this.getResultExcelName('xlsx');
    if (this.displayIndex < 0) {
      if (this.votingType === 'list' && this.pollData.rounds.length > 1) {
        for (const round of this.pollData.rounds) {
          this.apiService.getResultsXlsxRound(this.pollId, round.round, this.language).subscribe((res) => {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
            saveAs(blob, `${round.title} ${name}`);
          });
        }
      } else {
        this.apiService.getResultsXlsx(this.pollId, this.language).subscribe((res) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
          saveAs(blob, name);
        });
      }
    } else {
      this.apiService.getResultsXlsxRound(this.pollId, this.realIndex, this.language).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
        saveAs(blob, name);
      });
    }
  }

  downloadVoters() {
    const name = this.common.getVotersExcelName('xlsx', this.language);
    if (this.displayIndex < 0) {
      if (this.votingType === 'list' && this.pollData.rounds.length > 1) {
        for (const round of this.pollData.rounds) {
          this.apiService.getVotersXlsxRound(this.pollId, round.round, this.language).subscribe((res) => {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
            saveAs(blob, round.title + ' ' + name);
          });
        }
      } else {
        this.apiService.getVotersXlsx(this.pollId, this.language).subscribe((res) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
          saveAs(blob, name);
        });
      }
    } else {
      this.apiService.getVotersXlsxRound(this.pollId, this.realIndex, this.language).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
        saveAs(blob, name);
      });
    }
  }

  downloadParticipation() {
    const name = 'Quorum.pdf';
    this.apiService.getQuorumFile(this.pollId, this.language).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
      saveAs(blob, name);
    });
  }

  shareResults() {
    this.shouldDisplaySharePopup = true;
  }
  dismissSharePopup(event: boolean) {
    if (event) {
      this.isSending = true;
      this.shouldDisplaySharePopup = false;
      this.apiService.setPublish(this.pollId).subscribe((res) => {
        this.isSending = false;
        this.resultsShared = true;
      });
    } else {
      this.shouldDisplaySharePopup = false;
    }
  }

  dismissVoters() { this.displayVoterStatus = ''; }

  receiveVoterMessage(message: string): void {
    this.displayVoterStatus = message;
    if (message === 'participants') {
      this.apiService.getParticipants(this.pollId).subscribe((res) => {
        this.displayedVoters = res;
        this.votersTitle = 'Présent(s)';
      });
    }
    if (message === 'remaining' || message === 'all' || message === 'voted') {
      this.apiService.getRRemaining(this.pollId).subscribe((res: VoterVotedResponse) => {
        if (message === 'remaining') {
          this.displayedVoters = res.remainingVoters;
          this.votersTitle = 'Non votant(s)';
        }
        if (message === 'all') {
          this.displayedVoters = res.allVoters;
          this.votersTitle = 'Électeur(s)';
        }
        if (message === 'voted') {
          this.displayedVoters = res.votedVoters;
          this.votersTitle = 'Votant(s)';
        }
      });
    }
  }

  rejoinPoll() {
    this.router.navigate(['/poll-live/' + this.pollId]);
  }

  navigateHome() {
    this.router.navigate(['/polls']);
  }

  getElectionCalculated() {
    this.apiService.getResults(this.pollId).subscribe((res) => {
      if (Object.keys(res).length === 0 || (Object.keys(res).length === 1 && res[0].length === 0)) {
        this.calculating = true;
        const self = this;
        this.timer = setTimeout(() => {
          self.getElectionCalculated();
        }, 30000);
      } else {
        clearTimeout(this.timer);
        this.calculating = false;
      }
    });
  }

  initData() {
    this.apiService.getPoll(this.pollId).subscribe((res: ReceivedPoll) => {
      this.apiService.getPollPreview(this.pollId).subscribe((assessors: any) => {
        this.assessorsValidated = assessors.validatedAssessors >= Math.floor(res.assessors / 2) + 1;

      });
      this.isPublic = res.publicVote;
      this.is2FA = res.is2FA;
      this.title = res.name;
      this.votersCount = res.nbVoters;
      this.description = res.description;
      this.votingType = res.type;
      this.isLive = res.isLive;
      if (!this.isLive && res.assessors > 0) {
        this.handleAssessorSendStatus();
        this.canResendAssessors = false;
      }
      this.SMSOption = res.smsOption;
      this.startDate = new Date(res.startDate).toLocaleString();
      if (this.displayIndex !== -1 && new Date(res.rounds[this.displayIndex].openedAt).getTime() > 0) {
        this.startDate = new Date(res.rounds[this.displayIndex].openedAt).toLocaleString();
      }
      let displayedEndDate = new Date(res.endDate);
      if (displayedEndDate != undefined) {
        const todayDate = new Date();
        if (todayDate.getTime() < displayedEndDate.getTime()) {
          this.isActive = true;
        }
      }
      if (this.displayIndex !== -1 && new Date(res.rounds[this.displayIndex].closedAt).getTime() > 0) {
        displayedEndDate = new Date(res.rounds[this.displayIndex].closedAt);
      }
      this.endDateFormat = displayedEndDate;
      this.endDate = this.endDate + displayedEndDate.toLocaleString();

      this.resultsShared = res.shareResults;
      this.hasAssessors = res.assessors > 0;
      this.assessors = res.assessors;
      this.shouldReturnToPoll = res.hasBeenClosed !== true && (new Date(res.startDate).getTime() + 3600000 * 24 > new Date().getTime());
      this.isShareEnabled = res.rounds.filter(r => r.results != null).length > 0 || (new Date(res.endDate) < new Date());
      this.pollData = res;
      /** COMMENTED DUE TO A CRASH SINCE MULTI COLLEGE */
      // if (res.type === 'list' && res.rounds && res.rounds.length > 0) {
      //   this.setActiveElectionToDisplay(this.activeElectionToDisplay);
      // }
      if (this.displayIndex === -1) {
        this.apiService.getParticipation(this.pollId).subscribe((partRes: ParticipationResponse) => {
          if (partRes.votes != null) {
            this.votes = partRes.votes;
          }
          this.percentage = (this.votes / this.votersCount) * 100;
          this.percentageString = parseFloat(this.percentage.toFixed(2)).toLocaleString();
        }, (err: any) => {
          this.isError = true;
          this.errorMessage = 'Nous sommes désolés mais vous ne pouvez accéder au contenu \
                erreur ' + err.status;
        });
      } else {
        this.realIndex = this.isLive && res.rounds.length >= this.displayIndex ?
          res.rounds[this.displayIndex].round : this.displayIndex;
        this.apiService.getParticipationRound(this.pollId, this.realIndex).subscribe((partRes: ParticipationResponse) => {
          if (partRes.votes != null) {
            this.votes = partRes.votes;
          }
          this.percentage = (this.votes / this.votersCount) * 100;
          this.percentageString = parseFloat(this.percentage.toFixed(2)).toLocaleString();
        }, (err: any) => {
          this.isError = true;
          this.errorMessage = 'Nous sommes désolés mais vous ne pouvez accéder au contenu \
                erreur ' + err.status;
        });
      }
      if (this.hasAssessors) {
        this.apiService.getNonClosingAssessors(this.pollId).subscribe((res: Array<AssessorData>) => {
          this.remainingAssessors = res.length;
          console.log('remaining assessors : ', this.remainingAssessors);

        });
      }
    }, (err: any) => {
      this.isError = true;
      this.errorMessage = 'Nous sommes désolés mais vous ne pouvez accéder au contenu \
           erreur ' + err.status;
    });
    this.getElectionCalculated();
  }

  navigateToAudit() {
    this.router.navigate(['/poll-audit/' + this.pollId])
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.pollId = params.poll;
        this.blockchainLink = environment.settings.validation + this.pollId + this.common.getNewEnvironmentString();
        if (params.resolution == null) {
          this.displayIndex = -1;
        } else {
          this.displayIndex = parseInt(params.resolution, 10);
        }
        this.realIndex = this.displayIndex;
        this.initData();
      });
    const languageKey = 'userLanguage';
    const userLang = navigator.language || navigator[languageKey];
    this.language = userLang.substring(0, 2);
  }
}
